import { z } from "zod";
import { examConfigSchema } from "./exam-config";
import { pricingConfigSchema } from "./pricing";
import { programmeSchema } from "./programmes";

/** Response bodies of the Phase 0 endpoints (spec §7.2) — the executable contract for clients and server. */
export const pricingConfigResponseSchema = pricingConfigSchema;
export const programmesResponseSchema = z.object({ items: z.array(programmeSchema) });
export const programmeConfigResponseSchema = z.object({
  programme: programmeSchema,
  configs: z.array(examConfigSchema),
});
export const waitlistResponseSchema = z.object({ ok: z.literal(true) });
export const geoResponseSchema = z.object({ country: z.string().nullable(), allowed: z.boolean() });
